export enum MetricDataFetchType {
    NONE = 'none',
    HISTORY = 'history',
    DASHBOARD = 'dashboard',
    ALL = 'all',
}
